<template>
    <div :class="$style['auth0-unauthorized-page']">
        <div
            ref="auth0-unauthorized-page-default"
            :class="[$style['auth0-unauthorized-page-default'],$style['auth0-unauthorized-page-text-center']]"
        >
            <div :class="$style['auth0-unauthorized-page-default-title']">
                {{ title }}
            </div>
            <div :class="$style['auth0-unauthorized-page-default-message']">
                {{ message }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Unauthorized",
    data() {
        return {
            title: "It looks like you aren't allowed to view this page.",
            message: "Your account has expired or is otherwise inactive or you don't have access. Try closing your browser and logging back in, or contact Advisor Workstation support at (877) 409-0473 or email at: AdvisorSupport@morningstar.com."
        };
    }
};
</script>

<style lang="scss" module>
@import "@/styles";

@mixin awse-support-auth0-page-label() {
    padding-top: 40px;
    color: $mds-text-color-primary;
    text-align: center;
}

$ns: "auth0-unauthorized-page";
.#{$ns} {
    width: 50%;
    margin: 0 auto;
    margin-bottom: 60px !important;

    &-default {
        &-title {
            @extend %title;

            padding-top: 0 !important;
            margin: 51px 0 36px !important;
        }

        &-message {
            @include mds-level-2-heading;

            font-size: 23px !important;
        }
    }

    &-text-center {
        text-align: center;
    }
}
</style>
